// Pure rules for linking an unknown barcode (Stage 2D). Tested in barcodeLinkLogic.test.ts.
export const canLinkBarcodes = (role: string) => role === 'admin' || role === 'inventory_manager' || role === 'kitchen_manager'

export interface PackChoice {
  key: 'one' | 'purchase'
  qty: number
  label?: string
}

/** One base unit per scan, or one purchase unit when the item has one. */
export function packChoices(item: { purchase_unit_label?: string | null; purchase_unit_factor?: number | null }): PackChoice[] {
  const out: PackChoice[] = [{ key: 'one', qty: 1 }]
  if (item.purchase_unit_label && item.purchase_unit_factor && item.purchase_unit_factor > 0 && item.purchase_unit_factor !== 1) {
    out.push({ key: 'purchase', qty: item.purchase_unit_factor, label: item.purchase_unit_label })
  }
  return out
}
